import {observer} from "mobx-react";
import React, {useState} from "react";
import Store from "../store";
import ErrorMessage from "./error";
import {Container} from "@mui/material";
import {DarkButton} from "./buttons";
import {SignatureDialog} from "./signature-dialog";
import RenewalStore from "../stores/renewal-store";
import {CompanyDetailsEditor} from './company-details-editor';

const RenewStepOne = observer(({companyInfo}: { companyInfo: any }) => {
    const [errorMessage, setErrorMessage] = useState("");
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        if (!RenewalStore.getUpdatedCompanyInfo.officers.some(officer => officer.remove !== true)) {
            setErrorMessage('You must have at least one officer on your annual report.');
            return;
        }
        setErrorMessage('');
        if (RenewalStore.hasValidSignature) {
            Store.setRenewStep(2);
            return;
        }
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <CompanyDetailsEditor companyInfo={companyInfo}/>

            <ErrorMessage message={errorMessage}/>
            <Container maxWidth={'sm'} sx={{display: 'flex', flexDirection: 'column'}}>
                <DarkButton onClick={handleClickOpen}
                            sx={{p: 2, mt: 3}} disableElevation
                            variant={'contained'}>Proceed to payment</DarkButton>
            </Container>

            <SignatureDialog
                open={open}
                onClose={handleClose}
                onSigned={() => Store.setRenewStep(2)}
                officers={RenewalStore.getUpdatedCompanyInfo.officers}
                documentNumber={RenewalStore.getCompanyInfo['id']}
            />

        </>
    )


})


export default RenewStepOne
